export default __webpack_public_path__ + "static/media/24_thumbnail.61771d30.JPG";